import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface AccountPaymentAllocationItem {
    transactionId?: number | string | null;
    traNo: string;
    traType?: string | null;
    accountNo?: string | null;
    traAmount?: string | number | null;
    allcamount: string | number;
}

export interface AccountPaymentRequest {
    membercode: string;
    location?: string | null;
    paymode: string;
    allocated: AccountPaymentAllocationItem[];
    party_type: "vendor" | "customer";
    payment_desc?: string | null;
    cheque_no?: string | null;
    card_reference?: string | null;
    other_reference?: string | null;
    payer_name?: string | null;
    reference_no?: string | null;
    note?: string | null;
    cheque_date?: string | null;
}

export interface AccountPaymentResponse {
    docnos: string[];
}

export const saveAccountEntriesPayment = async (
    payload: AccountPaymentRequest,
): Promise<AccountPaymentResponse> => {
    try {
        const response: ApiResponse<AccountPaymentResponse> = (
            await apiClient.post("/transactions/account-entries/save", payload, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            const detail = error.response.data.detail;
            const message = typeof detail === "string" ? detail : JSON.stringify(detail);
            throw new Error(message);
        }

        throw new Error("Failed to save account payment");
    }
};

export interface CustomerReceiptLine {
    docno: string;
    invoice_no: string;
    description: string;
    invoice_amount: number;
    allocated_amount: number;
}

export interface CustomerReceipt {
    docnos: string[];
    customer_code: string;
    customer_name: string;
    user_name: string;
    location_label: string;
    payment_mode: string;
    cheque_no: string;
    cheque_date: string;
    payer_name: string;
    reference_no: string;
    note: string;
    amount: number;
    created_at: string;
    lines: CustomerReceiptLine[];
}

export interface CustomerReceiptSearchParams {
    q?: string;
    date_from?: string;
    date_to?: string;
    limit?: number;
    offset?: number;
}

export const getCustomerReceipts = async (
    params: CustomerReceiptSearchParams = {},
): Promise<CustomerReceipt[]> => {
    try {
        const response: ApiResponse<CustomerReceipt[]> = (
            await apiClient.get("/transactions/account-entries/customer-receipts", { params })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }
        throw new Error("Failed to load customer receipts");
    }
};
